export class Feature {
  private enabled: boolean;

  constructor(enabled: boolean = false) {
    this.enabled = enabled;
  }

  isEnabled(): boolean {
    return this.enabled;
  }
}

export class WithFeature {
  private feature: Feature;

  constructor() {
    this.feature = new Feature();
  }

  setupFeature(feature: Feature): void {
    this.feature = feature;
  }

  getFeature(): Feature {
    return this.feature;
  }
}
